import request from '@/config/axios'

export interface ActivityPrizeVO {
  id?: number
  activityId?: number
  name?: string
  prizeType?: number
  bizId?: number
  bizSnapshot?: Record<string, any>
  imageUrl?: string
  valueAmount?: number
  totalStock?: number
  restStock?: number
  winRate?: number
  /** 实际概率 = winRate / ΣwinRate（同活动，后端填充） */
  probability?: number
  limitType?: number
  limitCount?: number
  sorted?: number
  status?: number
}

export interface ActivityPrizePageReqVO extends PageParam {
  activityId?: number
  name?: string
  prizeType?: number
  status?: number
}

export const getActivityPrizePage = (params: ActivityPrizePageReqVO) => {
  return request.get({ url: '/promotion/activity-prize/page', params })
}

export const getActivityPrizeListByActivity = (activityId: number) => {
  return request.get({
    url: '/promotion/activity-prize/list-by-activity',
    params: { activityId }
  })
}

export const createActivityPrize = (data: ActivityPrizeVO) => {
  return request.post({ url: '/promotion/activity-prize/create', data })
}

export const updateActivityPrize = (data: ActivityPrizeVO) => {
  return request.put({ url: '/promotion/activity-prize/update', data })
}

export const deleteActivityPrize = (id: number) => {
  return request.delete({ url: '/promotion/activity-prize/delete', params: { id } })
}
